// extracted by mini-css-extract-plugin
module.exports = {"container":"advisory-module--container--1Qwm6","layout":"advisory-module--layout--HALt6","wrapper":"advisory-module--wrapper--2J9_X","text":"advisory-module--text--1HaAe"};